import appStore from 'store'
import api from './api'
import { PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,
    lotteryConfig: {
      id: 1,
      tenantId: 1,
      userOpThreshold: 0,
      userOpThresholdCoin: 'USDT',
    },
    tenantList: [],
  },
  getters: {},
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.items
      state.totalCount = payload.total
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setQueryType(state, payload) {
      state.queryType = payload
    },
    setUserinfoDetailDialogVisible(state, payload) {
      state.userinfoDetailDialogVisible = payload
    },
    setdialogVisible(state, payload) {
      state.dialogVisible = payload
    },
    setnodedetail(state, payload) {
      state.notedetail = payload
    },
    setUserinfoDetail(state, payload) {
      state.userinfoDetail = payload
    },
    setCountryCodeList(state, payload) {
      state.countryCodeList = payload
    },
    setLotteryConfig(state, payload) {
      state.lotteryConfig = payload
    },
    setTenantList(state, payload) {
      state.tenantList = payload
    },
  },

  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getUserList(query).then((res) => {
        if (res.code == 0) {
          commit('setUserList', res.data)
        }
      })
    },
    upgradePartner({ commit }, data) {
      return api.upgradePartner(data).then((res) => {
        return res
      })
    },
    upgradeRate({ commit }, data) {
      return api.upgradeRate(data).then((res) => {
        return res
      })
    },
    addLottery({ commit }, data) {
      return api.addLottery(data).then((res) => {
        return res
      })
    },
    addLotteryConfig({ commit }, data) {
      return api.addLotteryConfig(data).then((res) => {
        return res
      })
    },
    getLotteryConfig({ commit }, query = {}) {
      // commit('setPagination', { page: query.page, size: query.size })
      api.getLotteryConfig(query).then((res) => {
        if (res.code == 0) {
          commit('setLotteryConfig', res.data)
        }
      })
    },
    updLottery({ commit }, data) {
      return api.updLottery(data).then((res) => {
        return res
      })
    },
    getTenantList({ commit }, query = {}) {
      // commit('setPagination', { page: query.page, size: query.size })
      api.getTenantList(query).then((res) => {
        if (res.code == 0) {
          commit('setTenantList', res.data)
        }
      })
    },
  },
}

appStore.registerModule('activityLottery', store)
